import * as Yup from 'yup';

export default Yup.object().shape({
  month: Yup.string().required('SCHEMA_ERRORS.MONTH_REQUIRED')
});
